import { GET_ALL_KPI_DURATION } from "@/GraphQL/Queries";
import { useMutation, useQuery } from "@apollo/client";
import React, { useState } from "react";
import { Button, Card, CardBody, Col, Row, Table } from "reactstrap";
import moment from "moment";
import { useHistory } from "react-router";
import Loader from "@/containers/Account/Profile/components/Loader";
import DeleteIcon from "@mui/icons-material/Delete";
import { DELETE_KPI_DURATION } from "@/GraphQL/Mutation";
import Swal from "sweetalert2";
import BreadCrumb from "@/shared/components/BreadCrumb/BreadCrumb";
import SubmitLoading from "@/utils/HelperComponent/SubmitLoading";
import { Pagination } from "@mui/material";
export default function KpiDurationList() {
  const [currentPage, setCurrentPage] = useState(1);
  const limit = 10;
  const history = useHistory();
  const {
    data: kpiDurationData,
    loading,
    error,
    refetch,
  } = useQuery(GET_ALL_KPI_DURATION, {
    variables: {
      page: currentPage,
      size: limit,
    },
    fetchPolicy: "network-only",
  });

  const [deleteKpiDuration, { loading: deleteLoading }] =
    useMutation(DELETE_KPI_DURATION);
  const kpiDurationDatas = kpiDurationData?.getAllKpiDuration?.data;

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This KPI Duration will be permanently deleted.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const result = await deleteKpiDuration({
          variables: { id },
        });

        if (result?.data?.deleteKpiDuration?.status === "false") {
          Swal.fire(
            "Error",
            `${result?.data?.deleteKpiDuration?.message}`,
            "error"
          );
          return;
        }
        Swal.fire("Deleted!", "KPI Duration has been deleted.", "success");
        refetch?.();
      } catch (err) {
        Swal.fire("Error", "Failed to delete KPI Duration.", "error");
        console.error("Delete error:", err);
      }
    }
  };
  const breadCrumbData = [
    {
      name: "Dashboard",
      link: "/",
    },
    {
      name: "Kpi Duration",
    },
  ];
  const handleChange = (e, p) => {
    setCurrentPage(p);
    refetch({
      page: p,
    });
  };
  return (
    <Col>
      <Card>
        <CardBody>
          <Row>
            <Col>
              <BreadCrumb breadCrumbData={breadCrumbData} />
            </Col>
          </Row>
          <Row>
            <Col md={6} className="d-flex align-items-center">
              <h3 className="page-title mb-0">Kpi Duration List</h3>
            </Col>
            <Col
              md={6}
              className="d-flex justify-content-end align-items-center"
            >
              <Button
                onClick={() => history.push("/department/kpi-duration")}
                color="primary"
              >
                Create Duration
              </Button>
            </Col>
          </Row>
          <Table role="table" striped hover responsive>
            <thead>
              <tr role="row">
                <th>#</th>
                <th>Start</th>
                <th>End</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="8" className="text-center">
                    <SubmitLoading color="black" />
                  </td>
                </tr>
              ) : (
                kpiDurationDatas?.map((item, index) => (
                  <tr key={item?.id}>
                    <th>{index + 1}</th>
                    <td>{moment(item.start_date).format("MMMM, YYYY")}</td>
                    <td> {moment(item.end_date).format("MMMM, YYYY")}</td>
                    <td>
                      {" "}
                      <button
                        className="inbox__email-btn"
                        type="button"
                        aria-label="edit"
                        onClick={() => {
                          handleDelete(item?.id);
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>

          {kpiDurationDatas?.length > 0 ? (
            <Pagination
              className="mt-2"
              count={
                kpiDurationData?.getAllKpiDuration?.paginatorInfo?.lastPage
              }
              page={
                kpiDurationData?.getAllKpiDuration?.paginatorInfo?.currentPage
              }
              onChange={handleChange}
            />
          ) : null}
        </CardBody>
      </Card>
      {/* <Row>
        <Col md={6} className="d-flex align-items-center">
          <h3 className="page-title mb-0">Department List</h3>
        </Col>
        <Col md={6} className="d-flex justify-content-end align-items-center">
          <Button
  
            color="primary"
          >
        
            New Department
          </Button>
        </Col>
      </Row> */}
    </Col>
  );
}
